export interface NavItem {
  label: string;
  path: string;
  children?: NavItem[];
  description?: string;
}

export const mainNavigation: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Programs', path: '/programs' },
  { label: 'Team', path: '/team' },
  { label: 'Impact', path: '/impact' },
  { label: 'Stories', path: '/stories' },
  { label: 'Partners', path: '/partners' },
  { label: 'For Funders', path: '/funders' },
  { label: 'Volunteer', path: '/volunteer' },
  { label: 'Contact', path: '/contact' }
];

export const utilityNavigation: NavItem[] = [
  { label: 'Privacy', path: '/privacy' },
  { label: 'Terms', path: '/terms' },
  { label: 'Safeguarding', path: '/safeguarding' },
  { label: 'Press Kit', path: '/press-kit' }
];